import { render, staticRenderFns } from "./Snowflakes.vue?vue&type=template&id=5432f192&scoped=true&"
import script from "./Snowflakes.vue?vue&type=script&lang=js&"
export * from "./Snowflakes.vue?vue&type=script&lang=js&"
import style0 from "./Snowflakes.vue?vue&type=style&index=0&id=5432f192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432f192",
  null
  
)

export default component.exports